import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediaList from './media-list-model'
import {
  CreateMediaListAsync,
  DeleteMediaListAsync,
  LoadMediaListsAsync,
} from './mediaList-thunk'
const initialState: mediaListSliceState = {
  mediaList: [],
  selected_mediaList: '',
  is_loading_mediaList: false,
  is_creating_mediaList: false,
  is_deleting_mediaList: false,
}
export interface mediaListSliceState {
  mediaList: MediaList[]
  selected_mediaList?: string
  is_loading_mediaList: boolean
  is_creating_mediaList: boolean
  is_deleting_mediaList: boolean
}
export const mediaListSlice = createSlice({
  name: 'mediaList',
  initialState,
  reducers: {
    setSelectedmediaList: (state, action) => {
      state.selected_mediaList = action.payload
    },
    clearStatemediaList: (state) => {
      state.mediaList = []
      state.is_loading_mediaList = false
      state.is_creating_mediaList = false
      state.is_deleting_mediaList = false
    },
    mergemediaList: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediaList = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediaList = merge(state.mediaList, payload) as any
        }
      }
    },

    add_mediaList: (state, action) => {
      if (action.payload) {
        state.mediaList = [...state.mediaList, action.payload]
      }
    },
    set_mediaList: (state, action) => {
      let { key, value, id } = action.payload
      state.mediaList = state.mediaList.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediaListsAsync.pending, (state) => {
      state.is_loading_mediaList = true
    })
    builder.addCase(LoadMediaListsAsync.fulfilled, (state, action) => {
      state.is_loading_mediaList = false
      if (action.payload) {
        state.mediaList = action.payload
      }
    })
    builder.addCase(LoadMediaListsAsync.rejected, (state) => {
      state.is_loading_mediaList = false
    })
    builder.addCase(CreateMediaListAsync.pending, (state) => {
      state.is_creating_mediaList = true
    })
    builder.addCase(CreateMediaListAsync.fulfilled, (state) => {
      state.is_creating_mediaList = false
    })
    builder.addCase(CreateMediaListAsync.rejected, (state) => {
      state.is_creating_mediaList = false
    })
    builder.addCase(DeleteMediaListAsync.pending, (state) => {
      state.is_deleting_mediaList = true
    })
    builder.addCase(DeleteMediaListAsync.fulfilled, (state, action) => {
      state.is_deleting_mediaList = false
      if (state.mediaList) {
        state.mediaList = state.mediaList.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediaListAsync.rejected, (state) => {
      state.is_deleting_mediaList = false
    })
  },
})

export const {
  clearStatemediaList,
  setSelectedmediaList,
  set_mediaList,
  mergemediaList,
  add_mediaList,
} = mediaListSlice.actions

export const get_mediaList =
  (id?: string) =>
  (state: {
    mediaList: {
      mediaList: MediaList[]
    }
  }): MediaList | null => {
    let temp = state?.mediaList?.mediaList?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.mediaList?.mediaList[0] || null
  }
export const get_selected_mediaList = (state: {
  mediaList: mediaListSliceState
}): MediaList | null => {
  let id = state?.mediaList?.selected_mediaList
  let temp = state?.mediaList?.mediaList?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediaList = (state: {
  mediaList: {
    mediaList: MediaList[]
  }
}): MediaList[] => {
  let temp = state?.mediaList?.mediaList
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediaList_busy = (state: {
  mediaList: mediaListSliceState
}) => {
  return (
    state?.mediaList.is_deleting_mediaList ||
    state?.mediaList.is_loading_mediaList ||
    state?.mediaList.is_creating_mediaList
  )
}
export const is_deleting_mediaList_busy = (state: {
  mediaList: mediaListSliceState
}) => {
  return state?.mediaList.is_deleting_mediaList
}
export const is_loading_mediaList_busy = (state: {
  mediaList: mediaListSliceState
}) => {
  return state?.mediaList.is_loading_mediaList
}
export const is_creating_mediaList_busy = (state: {
  mediaList: mediaListSliceState
}) => {
  return state?.mediaList.is_creating_mediaList
}

export default mediaListSlice.reducer
